import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import debounce from 'lodash/debounce';
import ReactTags from 'react-tag-autocomplete';

import { Api } from '@shell/shell-ui';

export default function Tag(props) {
  const { url, placeholder } = props;
  const [field,, helpers] = useField(props);
  const [suggestions, setSuggestions] = useState([]);

  const handleAddition = useCallback(async (tag) => {
    if (!tag.id && props.url) {
      try {
        const { data } = await Api.post(`${ url }`, { name: tag.name });
        tag.id = data.id;
      } catch (e) {}
    }

    helpers.setValue([].concat(field.value || [], tag));
    setSuggestions([]);
  }, [field.value]);

  const handleDelete = useCallback((tag) => {
    const cTags = [...field.value];
    cTags.splice(tag, 1);
    helpers.setValue(cTags);
  }, [field.value]);

  const fetchTags = useCallback(debounce(async (search) => {
    if (!url) {
      return false;
    }
    setSuggestions([]);
    if (search.length < 3) {
      return false;
    }

    const tagsIds = field.value?.map(({ id }) => id) ?? [];

    try {
      const { data } = await Api.get(`${ url }?size=99999&filter.name=${ search }`);
      const list = data.content
        .filter((item) => !tagsIds.includes(item.id));

      setSuggestions(list);
    } catch (e) {
      console.log({ e });
    }

    return true;
  }, 1000), [field.value]);

  return (
    <ReactTags
      allowNew
      placeholder={placeholder}
      tags={field.value ?? []}
      suggestions={suggestions}
      handleDelete={handleDelete}
      handleAddition={handleAddition}
      handleInputChange={fetchTags}
    />
  );
}

Tag.defaultProps = {
  url: null,
  placeholder: 'Add new tag',
};

Tag.propTypes = {
  url: PropTypes.string,
  placeholder: PropTypes.string,
};
